import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import {
  API_LISTAR_FONTES_ENERGIA,
  API_CRIAR_FONTES_ENERGIA,
  API_EXCLUIR_FONTES_ENERGIA,
  API_ATUALIZAR_FONTES_ENERGIA,
} from 'store/modules/api/fontesEnergia.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_FONTES_ENERGIA.success:
      return payload.sort((a, b) => a.fonteEnergetica.localeCompare(b.fonteEnergetica))
    case API_CRIAR_FONTES_ENERGIA.success:
      return [...state, payload].sort((a, b) => a.fonteEnergetica.localeCompare(b.fonteEnergetica))
    case API_ATUALIZAR_FONTES_ENERGIA.success: return state.map((e) => (e.id === payload.id ?
      payload : e))
    case API_EXCLUIR_FONTES_ENERGIA.success: return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_FONTES_ENERGIA)

const isSaving = loadingReducer(false, API_CRIAR_FONTES_ENERGIA)
const isUpdate = loadingReducer(false, API_ATUALIZAR_FONTES_ENERGIA)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
